import React, { useEffect, useState } from 'react';
import Modal from '../../Modal';
import { useTranslation } from 'react-i18next';

export default function LoginRegisterModal(props: { open: boolean; onClose: () => void }) {
    const [loginRegister, setLoginRegister] = useState<'login' | 'register' | 'activateAccount'>(
        'login',
    );
    useEffect(() => {
        setLoginRegister('login');
    }, [props.open]);
    const {t} = useTranslation();

    return (
        <Modal show={props.open} onClose={props.onClose} width={600} showClose={true}>
            <div
                className={
                    'absolute mb-2 flex w-fit flex-col items-center whitespace-nowrap p-4 font-montserrat text-base font-medium uppercase tracking-[.06em]'
                }>
                SPRAWNE MIASTO
                <div className={'h-0.5 w-1/2 rounded-full bg-SM-yellow'} />
            </div>
            <div className={'px-8 pt-20 pb-14 sm:px-16'}>
                {/* {loginRegister === 'register' && (
                    <Register
                        toActivateAccount={() => {
                            setLoginRegister('activateAccount');
                        }}
                        toLogin={() => {
                            setLoginRegister('login');
                        }}
                    />
                )}

                {loginRegister === 'login' && (
                    <Login
                        toRegister={() => {
                            setLoginRegister('register');
                        }}
                        closeModal={props.onClose}
                    />
                )}

                {loginRegister === 'activateAccount' && <ActivateAccount onClose={props.onClose} />} */}

                {t('translation:login.unavaiable')}
            </div>
        </Modal>
    );
}
